import styled from '@emotion/styled/macro';

import TabNavigation from '../../styledComponents/UI/TabNavigation/TabNavigation';

export const StyledTabNavigation = styled(TabNavigation)`
  margin: 1.875rem 2.5rem 0;
`;
